import { Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';

import { PaymentConstant } from 'src/app/constants';
import { PaymentRequestType } from 'src/app/models';

export const PAYMENT_TYPE_KEYS: Record<string, string> = {
  cash: 'payment.cash',
  credit_card: 'payment.creditCard',
  debit_card: 'payment.debitCard',
  gift_card: 'payment.giftCard',
  bill_to_room: 'payment.billToRoom',
  charge_account: 'payment.chargeAccount',
  charge_to_department: 'payment.chargeToDepartment',
  meal_plan: 'payment.mealPlan',
  cash_penny_rounding: 'payment.cashPennyRounding',
  'Zero Value': 'payment.zeroValue',
  'Cash Penny Rounding': 'payment.cashPennyRounding'
};

@Pipe({
  name: 'paymentTypeLabel'
})
export class PaymentTypeLabelPipe implements PipeTransform {
  constructor(private readonly translocoService: TranslocoService) {}

  /**
   * @param lang active locale code. Passing it keeps the pipe pure, so it
   * re-evaluates on a language switch instead of relying on a sibling
   * `| transloco` to mark the view dirty.
   * @returns '' for an unmapped type, matching what the previous
   * `| replace | titlecase` chain rendered.
   */
  transform(type: PaymentRequestType | string, lang?: string): string {
    // `type` is usually a server-side PaymentRequestType (e.g. 'Pos::Transaction::Cash').
    // Some callers (e.g. the Payment Method filter) already pass the snake_case
    // PaymentType key directly (e.g. 'credit_card'); fall back to it unchanged
    // so PAYMENT_TYPE_KEYS below still finds a match.
    const rawLabel = PaymentConstant.PAYMENT_REQUEST_TYPE_MAP[type] ?? type;
    const fallback = rawLabel ? String(rawLabel).replace(/_/g, ' ') : '';
    const key = PAYMENT_TYPE_KEYS[rawLabel];
    if (!key) {
      return fallback;
    }
    const translated = this.translocoService.translate(
      key,
      {},
      lang ? lang.split('-')[0] : undefined
    );
    // Transloco echoes the key back when the bundle for an explicitly
    // requested language has not loaded yet. Show the old rendering for that
    // window rather than a raw `payment.creditCard` in the transaction list.
    return translated === key ? fallback : translated;
  }
}
